import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "font-sourcesanspro-semibold text-xs2"
}

import { IonIcon } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LabelTopLeft',
  props: {
	class: { type: String },
	label: { type: String },
	labelContainerClass: { type: String },
	icon: { type: String },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([props.class, "absolute left-0 top-0 w-0 h-0 border-solid border-b-[70px] border-l-[70px] border-transparent rounded-tl-md z-10"])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([props.labelContainerClass, "absolute -rotate-[45deg] z-20"])
    }, [
      (props.icon)
        ? (_openBlock(), _createBlock(_unref(IonIcon), {
            key: 0,
            icon: props.icon
          }, null, 8, ["icon"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.label), 1))
    ], 2)
  ], 64))
}
}

})